export var AUTH_FETCH_ROUTES = {
    group: 'auth',
    login: {
        url: "".concat(process.env.REACT_APP_API_URL, "/Auth/login"),
        fetch_name: 'login',
        async_thunk_route: 'auth/login',
    },
    registration: {
        url: "".concat(process.env.REACT_APP_API_URL, "/account/registration"),
        fetch_name: 'registration',
        async_thunk_route: 'auth/registration',
    },
    refresh: {
        url: "".concat(process.env.REACT_APP_API_URL, "/auth/refresh"),
        fetch_name: 'refresh',
        async_thunk_route: 'auth/refresh',
    },
    sms: {
        url: "".concat(process.env.REACT_APP_API_URL, "/sms"),
        fetch_name: 'smscode',
        async_thunk_route: 'smsRequest',
    },
    smsApprove: {
        url: "".concat(process.env.REACT_APP_API_URL, "/sms/approve"),
        fetch_name: 'codeapprove',
        async_thunk_route: 'code/approve',
    },
    fileUpload: {
        url: "".concat(process.env.REACT_APP_API_URL, "/File"),
        fetch_name: 'fileupload',
        async_thunk_route: 'fileupload',
    },
};
